import React from 'react';
import './RequiredStar.scss';

const RequiredStar = () => {
    return <span className="required-star">*</span>;
};

export default RequiredStar;
